<template>
<div>




<div @click='select($event, data)' v-for="(data, index) in foundData.displayIds">
     <v-card
     primary
     hover
     :dark = "data.add_info.selected"
     class="video_wrapper selectable"

      >





       <v-card-title  class="selectable"   >
  <a target="_blank" v-bind ='{href: "https://vk.com/video"+data.owner_id+"_"+data.id}'>  <h3 style="color:#4A76A8">     {{data.title}}   </h3>  </a>
       </v-card-title>

<v-card-text class="selectable">
  <v-img  class="selectable"  v-bind ='{src:data.photo_320}'  >

  </v-img>
</v-card-text>

<v-card-actions class="selectable">

  <v-btn flat>
  <v-icon left > mdi-thumb-up </v-icon>
  {{data.likes.count}}
  </v-btn>

  <v-btn flat>
  <v-icon> mdi-comment </v-icon>
  {{data.comments}}
  </v-btn>

  <v-btn flat>
  <v-icon> mdi-share </v-icon>
  {{data.reposts.count}}
  </v-btn>
<v-spacer></v-spacer>
  <v-btn small flat  >
  <v-icon> mdi-eye </v-icon>
  {{data.views}}
  </v-btn>

</v-card-actions>
     </v-card>
</div>

<v-btn   v-if="loadMore" :loading="this.loadingMore"  block flat  color="#4A76A8"  @click="offSetChanger(foundData,'videos')"
>
  показать еще {{loadMore}}
 </v-btn>


</div>
</template>




<script>
import axios from 'axios'
export default {

props: ['foundData'],
 data: function(){
  return {
    loadingMore:false,
   isSelected: false
  }
},
computed:{
 loadMore(){

   if(this.foundData.displayIds.length < 20){
     this.offSetChanger(this.foundData,'videos')
     return this.foundData.foundIds.length - this.foundData.displayIds.length
   } else return this.foundData.foundIds.length - this.foundData.displayIds.length
 },
},
methods: {
  offSetChanger (data,type) {
    this.foundData.foundIds = this.foundData.foundIds.filter(item=> item.length)
    let pagesString =  data.foundIds.slice(data.offset, data.offset+20)
    data.offset = data.offset+pagesString.length
  if(pagesString.join(',') !== ''){
    this.loadingMore = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
         method: 'POST',
         data: {
           dataType: type,
           dataString:  pagesString.join(','),
           addInfo:{selected:data.selector}
         }
       })
       .then( response => {
        data.displayIds =   data.displayIds.concat(response.data)
        this.loadingMore = false
       })
     }
  },


 select: function(event,data){


   console.log( event.target.className)
   let classes = event.target.className.split(' ')
    if(classes.indexOf('selectable') !== -1 || classes.indexOf('v-responsive__content') !== -1){

      data.add_info.selected = !data.add_info.selected
       if(data.add_info.selected  ){

         this.foundData.selectedIds.push(data.owner_id+'_'+data.id)



       } else this.foundData.selectedIds.splice(this.foundData.selectedIds.indexOf(data.id),1)


    //    event.target.className = 'page_list_row-selected'
  }


},

}
}
</script>

<style>
.non_decoration{

text-decoration:none !important ;

}





.clearfloat:after {
 content: "";
 display: table;
 clear: both;
}

.page_list_row-selected{
background-color : #EDF0F5;
border-radius : 7px
}






.page_list_row .page_info  {
   padding-left:10px;
 padding-top: 10px;
 float: left;
   margin-bottom: 5px;
 margin-right: 25px;
   overflow: hidden;

   width: 170px;
 height: 110px;
}

.labeled_name{
    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
}

.page_list_row .labeled {

   color: #656565;
}



  .func_bts {
   margin: 5px 0 0 10px;
   margin-top: 5px;
   margin-right: 15px;
   margin-bottom: 0px;
   margin-left: 10px;
   max-width: 155px;
   float: left;
   text-align: right;


 }

 .func_bts button {

   min-width: 145px;
 padding: 7px 16px 8px;
   margin: 0;
   font-size: 12.5px;
   display: inline-block;
   zoom: 1;
   cursor: pointer;
   white-space: nowrap;
   outline: none;
   font-family: -apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif;
   vertical-align: top;
   line-height: 15px;
   text-align: center;
   text-decoration: none;
   background: none;
   background-color: #5181b8;
   color: #fff;
   border: 0;
   border-radius: 7px;
   box-sizing: border-box;
   line-height: 11px;
 }


.video_wrapper{
padding-top: 2px;

margin: 15px;
margin-bottom: 25px;
}

#video_wrap{
width: 315px;
height: 180px;
}


#video_title {
width:310;
}
</style>
